import React, { useContext } from "react";
import "../../styles/pages/home/ThankYouPage.scss";
import { Trans, useTranslation } from "react-i18next";
import { GlobalContext } from "../../App";

function ThankYouPage() {
  const { infoData } = useContext(GlobalContext);
  const { t, i18n } = useTranslation();

  return (
    <div className="thank-you-page-container">
      <div className="thank-you-title">
        <Trans i18nKey="thankYouPage:thankyou_title" />
      </div>
      <div className="thank-you-text">
        {i18n.language === "hk" ? (
          <span>
            <Trans i18nKey="thankYouPage:thankyou_text">
              {infoData.title_tc}
              {infoData.title_tc}
            </Trans>
          </span>
        ) : (
          <span>
           <Trans i18nKey="thankYouPage:thankyou_text">
              {infoData.title_eng}
              {infoData.title_eng}
            </Trans>
          </span>
        )}
      </div>
    </div>
  );
}

export default ThankYouPage;
